var _path, _path2, _mask, _path3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _mask2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibraryWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H6.5V29.5H2C1.17157 29.5 0.5 28.8284 0.5 28V2Z",
    stroke: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.5H12C12.8284 0.5 13.5 1.17157 13.5 2V29.5H7.5V0.5Z",
    stroke: "#ffffff"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_238_72",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 4H19.5C19.7761 4 20 4.22386 20 4.5V28C20 29.1046 19.1046 30 18 30H14V4Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H19.5C19.7761 4 20 4.22386 20 4.5V28C20 29.1046 19.1046 30 18 30H14V4Z",
    stroke: "#ffffff",
    strokeWidth: 2,
    mask: "url(#path-3-inside-1_238_72)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 4.5,
    x2: 6,
    y2: 4.5,
    stroke: "#ffffff"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 4.5,
    x2: 13,
    y2: 4.5,
    stroke: "#ffffff"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 25.5,
    x2: 13,
    y2: 25.5,
    stroke: "#ffffff"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 25.5,
    x2: 6,
    y2: 25.5,
    stroke: "#ffffff"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 16.8,
    y1: 8.8,
    x2: 16.8,
    y2: 13.2,
    stroke: "#ffffff",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 16.8,
    y1: 18.8,
    x2: 16.8,
    y2: 23.2,
    stroke: "#ffffff",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 19.8626,
    y1: 9.51924,
    x2: 26.8626,
    y2: 7.51924,
    stroke: "#ffffff"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 20.8608,
    y1: 12.5198,
    x2: 27.5839,
    y2: 10.5704,
    stroke: "#ffffff"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-2_238_72",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6078 4.75865C18.4792 4.22154 18.8104 3.68189 19.3475 3.5533L24.5064 2.3182C25.5806 2.06102 26.6599 2.72336 26.9171 3.79757L32.2989 26.277C32.5561 27.3512 31.8938 28.4305 30.8196 28.6877L26.6332 29.69C25.559 29.9472 24.4797 29.2848 24.2225 28.2106L18.6078 4.75865Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6078 4.75865C18.4792 4.22154 18.8104 3.68189 19.3475 3.5533L24.5064 2.3182C25.5806 2.06102 26.6599 2.72336 26.9171 3.79757L32.2989 26.277C32.5561 27.3512 31.8938 28.4305 30.8196 28.6877L26.6332 29.69C25.559 29.9472 24.4797 29.2848 24.2225 28.2106L18.6078 4.75865Z",
    stroke: "#ffffff",
    strokeWidth: 3,
    mask: "url(#path-12-inside-2_238_72)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryWhite);
export default __webpack_public_path__ + "static/media/libraryWhite.3a4d0009f2ba29f1bb5a9752a76a19c2.svg";
export { ForwardRef as ReactComponent };